<template>
  <v-card class="px-5 elevation-0">
    <v-card-text>
      <v-row>
        <v-col cols="4" class="pr-5">
          <v-row>
            <v-col cols="12" class="py-0">
              <h3 class="input-text input-text_title">Período Referência</h3>
            </v-col>
            <v-col cols="12" class="py-0">
              <p class="mb-0 input-text input-text_subtitle">Selecione início e o fim deste período</p>
            </v-col>
            <v-col cols="12" class="py-0">
              <mf-date-range-picker
                outlined
                icon
                show-days-counter
                :initial-date="filtersDecomposition.referencyDate[0]"
                :final-date="filtersDecomposition.referencyDate[1]"
                :max="lastUpdated"
                @input="filtersDecomposition.referencyDate = $event"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" class="px-5">
          <v-row>
            <v-col cols="12" class="py-0">
              <h3 class="input-text input-text_title">Período Atual</h3>
            </v-col>
            <v-col cols="12" class="py-0">
              <p class="mb-0 input-text input-text_subtitle">Selecione início e o fim deste período</p>
            </v-col>
            <v-col cols="12" class="py-0">
              <mf-date-range-picker
                outlined
                icon
                show-days-counter
                :initial-date="filtersDecomposition.currentDate[0]"
                :final-date="filtersDecomposition.currentDate[1]"
                :messages-error="!isDaysCountEqual"
                :messages-tooltip="tooltipMessage"
                :max="lastUpdated"
                @input="filtersDecomposition.currentDate = $event"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name: 'DecompositionFilters',
  props: {
    value: {
      type: Object,
      required: true,
    },
    lastUpdated: {
      type: String,
      default: '',
    },
  },
  data: () => ({}),
  computed: {
    filtersDecomposition: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    referencyDaysCount() {
      const { referencyDate } = this.filtersDecomposition
      const startDate = DateTime.fromISO(referencyDate[0])
      const endDate = DateTime.fromISO(referencyDate[1])
      const { days } = endDate.diff(startDate, 'days').toObject()

      return days + 1
    },
    currentDaysCount() {
      const { currentDate } = this.filtersDecomposition
      const startDate = DateTime.fromISO(currentDate[0])
      const endDate = DateTime.fromISO(currentDate[1])
      const { days } = endDate.diff(startDate, 'days').toObject()

      return days + 1
    },
    selectedPeriodMessage() {
      const { referencyDate } = this.filtersDecomposition
      const referencyDays = this.referencyDaysCount
      let formatSelectedPeriodMessage = `Você selecionou ${referencyDays}
          dias no período de referência. Selecione ${referencyDays} no período atual para a análise ser mais precisa.`

      return referencyDate.length && !referencyDate.includes('') ? formatSelectedPeriodMessage : ''
    },
    tooltipMessage() {
      if (this.isDaysCountEqual) return ''
      return `Para obter uma análise mais precisa, selecione no Período Atual a mesma quantidade de dias que você selecionou
      no Período de Referência (${this.referencyDaysCount} dias).`
    },
    isDaysCountEqual() {
      return this.referencyDaysCount === this.currentDaysCount
    },
  },
}
</script>

<style lang="scss">
.v-slide-group__wrapper {
  max-height: 200px;
  overflow-y: auto;
}
</style>
